import React from 'react';
import { motion } from 'framer-motion';
import { Swords, Clock } from 'lucide-react';
import { ClubBadge } from './shared';

const MatchRow = ({ match, isResult }) => {
  const homeName = match.home_club?.name || 'TBD';
  const awayName = match.away_club?.name || 'TBD';

  return (
    <div className="px-4 py-3 flex items-center gap-3" data-testid={`match-${match.match_id}`}>
      <div className="text-[10px] text-slate-500 w-8 text-center flex-shrink-0 uppercase tracking-widest">G{match.match_day}</div>
      <div className="flex-1 flex items-center justify-center gap-2 min-w-0">
        <span className="text-sm font-medium text-right flex-1 truncate">{homeName}</span>
        <ClubBadge logo={match.home_club?.logo} name={homeName} colors={match.home_club?.colors} size="xs" />
        {isResult ? (
          <span className="bg-[#050508] px-3 py-1 rounded text-sm font-mono font-bold border border-white/10 inline-flex items-center gap-1 flex-shrink-0">
            <span className={match.home_score > match.away_score ? 'text-[#00E676]' : 'text-white'}>{match.home_score}</span>
            <span className="text-slate-500">-</span>
            <span className={match.away_score > match.home_score ? 'text-[#00E676]' : 'text-white'}>{match.away_score}</span>
          </span>
        ) : (
          <span className="text-slate-500 text-xs flex-shrink-0">vs</span>
        )}
        <ClubBadge logo={match.away_club?.logo} name={awayName} colors={match.away_club?.colors} size="xs" />
        <span className="text-sm font-medium text-left flex-1 truncate">{awayName}</span>
      </div>
      {!isResult && match.match_date && (
        <div className="text-right flex-shrink-0 text-[10px] text-slate-500">
          <p>{new Date(match.match_date).toLocaleDateString('it-IT', { day: '2-digit', month: 'short' })}</p>
          <p className="text-[#FFEA00] font-mono">{new Date(match.match_date).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}</p>
        </div>
      )}
    </div>
  );
};

const MatchList = ({ title, icon: Icon, iconColor, matches, isResult, emptyText }) => (
  <div className="bg-[#0a0d15] border border-white/10 overflow-hidden">
    <div className="px-4 py-3 border-b border-white/10 flex items-center gap-2">
      <Icon size={16} className={iconColor} />
      <h3 className="font-heading text-sm uppercase tracking-wider font-bold">{title}</h3>
    </div>
    {matches.length === 0 ? (
      <div className="p-6 text-center text-slate-500 text-sm">{emptyText}</div>
    ) : (
      <div className="divide-y divide-white/5">
        {matches.map((m) => <MatchRow key={m.match_id} match={m} isResult={isResult} />)}
      </div>
    )}
  </div>
);

export const MatchesSection = ({ recentResults, upcomingMatches, isItalian }) => (
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4" data-testid="matches-section">
    <MatchList
      title={isItalian ? 'Risultati Recenti' : 'Recent Results'}
      icon={Swords}
      iconColor="text-[#00E676]"
      matches={recentResults}
      isResult
      emptyText={isItalian ? 'Nessun risultato ancora' : 'No results yet'}
    />
    <MatchList
      title={isItalian ? 'Prossime Partite' : 'Upcoming Matches'}
      icon={Clock}
      iconColor="text-[#00F0FF]"
      matches={upcomingMatches}
      isResult={false}
      emptyText={isItalian ? 'Nessuna partita programmata' : 'No upcoming matches'}
    />
  </motion.div>
);
